import { SpecialAttackSkill, StatusSkill } from "../../core/skill";
import { Effect, RoundEffect } from "../../core/effect";
import { Timing } from "../../core/timing";
import { Ability } from "../../core/ablvl";

import * as type from "../../core/type";
import * as cond from "../../core/cond";
import * as effect from "../../core/effect";
import * as pred from "../../core/pred";
import * as state from "../../core/state";

export const 破浪念闪 = new SpecialAttackSkill(
    "破浪念闪",
    type.水·超能,
    [
        "吸取对手最大体力的1/4，体力低于1/2时吸取效果翻倍",
        "消除对手的能力提升，消除成功令对手睡眠，未触发则令对手2回合内无法使用属性技能",
    ],
    80,
    [
        new Effect(
            new effect.吸取体力(({ sbjPet }) => Math.round(sbjPet.最大体力 * (1 / 4)), undefined, undefined, cond.若自身体力低于x分之一(2)),
            Timing.onDamage,
        ),
        new Effect(
            new effect.消除强化(),
            Timing.onDamage,
            undefined,
            [
                new Effect(
                    new effect.施加异常状态(new state.睡眠()),
                    Timing.triggered,
                    undefined,
                    [
                        new RoundEffect(
                            Timing.untriggered,
                            2,
                            new effect.属性封印(),
                            Timing.beforeSkillHit,
                            undefined,
                            true,
                        )
                    ]
                )
            ]
        )
    ],
    3,
);

export const 蓝色水翼 = new StatusSkill(
    "蓝色水翼",
    [
        "若当前拥有回合类效果，则使当前所有的回合类效果延长2回合（最多延长到4回合），否则2回合内自身的回合类效果无法被消除",
        "4回合内，每回合恢复自身最大体力的1/3并造成等量的固定伤害，体力低于1/2时恢复效果翻倍",
        "3回合内，自身受到的固定伤害和百分比伤害减少50%",
    ],
    [
        new RoundEffect(
            Timing.onSkillHit,
            4,
            new effect.回血·固伤(pred.自身最大体力的x分之一(3), undefined, undefined, cond.若自身体力低于x分之一(2)),
            Timing.actionEnd,
            undefined,
            false,
            [],
        ),
    ],
);

export const 幻舞激流 = new StatusSkill(
    "幻舞激流",
    [
        "全属性+1，同时使对手全属性-1",
        "4回合内免疫并反弹异常状态",
        "下2回合先制+2并且直接攻击必定致命一击",
        "3回合内，对手受到的固定伤害和百分比伤害提升50%",
    ],
    [
        new Effect(new effect.强化(), Timing.onSkillHit),
        new Effect(new effect.弱化(), Timing.onSkillHit),
        new RoundEffect(
            Timing.onSkillHit,
            2,
            new effect.暴击(),
            Timing.beforeDamage,
            undefined,
            false,
            [],
        ).nextRound(),
    ],
);

export const 断流怒啸 = new SpecialAttackSkill(
    "断流怒啸",
    type.水,
    [
        "若打出致命一击，则下1回合必定先出手",
        "若造成的攻击伤害超过300，则免疫下1次受到的异常状态",
        "3回合内，每回合附加300点固定伤害",
    ],
    150,
    [
        new RoundEffect(
            Timing.onSkillHit,
            3,
            new effect.固伤(300),
            Timing.onDamage,
            undefined,
            false,
            [],
        ),
    ],
);

export const 异光幻流 = new SpecialAttackSkill(
    "异光幻流",
    type.水·超能,
    [
        "无视对手免疫伤害效果",
        "消除对手的回合类效果，消除成功则2回合内对手无法通过技能恢复体力",
        "附加自身特攻和速度总和25%的固定伤害，每次使用增加10%，最高45%",
        "当回合击败对手，则减少对手下只出战精灵最大体力的1/2",
    ],
    160,
    [
        new Effect(new effect.消除回合(), Timing.onDamage),
        new Effect(
            new effect.固伤(pred.自身特攻和速度总和的百分之x(25), pred.自身特攻和速度总和的百分之x(10), pred.自身特攻和速度总和的百分之x(45)),
            Timing.onDamage,
        ),
    ],
    undefined,
    true,
);
